export default __webpack_public_path__ + "static/media/DRIVERLICENSEDOCTORCERTIFICATE_EN.1d24cf0c.png";